import clsx from 'clsx';
import { h, render, Fragment } from 'preact';
import { useState } from 'preact/hooks';
import { parseLinks } from 'utils/helpers';

export default (element, data) => {
  const init = () => {
    render(<ContentFullWidthSection />, element);
  };

  const ContentFullWidthSection = () => {
    const content = data.content.split('[more]');
    const [expandContent, setExpandContent] = useState(false);

    return (
      <div
        className={clsx(
          'py-8 px-5 laptop:py-15 laptop:px-10 !font-normal',
          data.text_style === 'subhead' ? 'subheading-h5' : 'font-16',
        )}
        style={{
          backgroundColor: data.background_color,
        }}
      >
        <p className="inline"
           dangerouslySetInnerHTML={{ __html: parseLinks(content[0]) }}
        ></p>
        {content[1] && (
          <>
            <p className={clsx(!expandContent ? 'inline' : 'hidden')}>... </p>
            <a
              className={clsx(!expandContent ? 'inline' : 'hidden')}
              href="#more"
              onClick={() => setExpandContent(!expandContent)}
            >
              Read More
            </a>
            <p
               className={clsx(expandContent ? 'inline' : 'hidden')}
               dangerouslySetInnerHTML={{ __html: parseLinks(content[1]) }}
            ></p>
            <a
              className={clsx(expandContent ? 'inline' : 'hidden')}
              href="#less"
              onClick={() => setExpandContent(!expandContent)}
            >
              Read Less
            </a>
          </>
        )}
      </div>
    );
  };

  init();
};
